import React from 'react';
import { WalletErrorBanner } from '../../../../components/wallet-error-banner';
import { useWalletRegistrationErrorContext } from '../../contexts/wallet-registration-error-context';

export const WalletRegistrationErrorBanner = () => {
  const { errors } = useWalletRegistrationErrorContext();

  return <WalletErrorBanner errors={errors} />;
};
